/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './gateway-configuration.scss';

import beautify from 'js-beautify';

const js_beautify = beautify.js;


/*@ngInject*/
export default function GatewayConfigurationController($scope, $mdDialog, $filter, $translate, configurationService, types, utils,
                                                       excludeConfigurationTypes, configuration, isAdd, isReadOnly, isGroup, showRemote, groupConfigurations) {

    var vm = this;

    vm.$onInit = function () {
        vm.types = types;
        vm.isAdd = isAdd;
        vm.isReadOnly = isReadOnly;
        vm.isGroup = isGroup;
        vm.showRemote = showRemote;
        vm.groupConfigurations = groupConfigurations;

        vm.configuration = configuration;

        vm.configurationTypes = {};
        for (var configurationType in vm.types.configurationType) {
            if (excludeConfigurationTypes.indexOf(configurationType) == -1) {
                vm.configurationTypes[configurationType] = vm.types.configurationType[configurationType];
            }
        }

        if (vm.configuration.updateTs) {
            vm.updatedTime = $filter('date')(vm.configuration.updateTs, 'yyyy-MM-dd HH:mm:ss');
        } else {
            vm.updatedTime = '';
        }
        if (vm.configuration.remoteUpdateTs) {
            vm.remoteUpdatedTime = $filter('date')(vm.configuration.remoteUpdateTs, 'yyyy-MM-dd HH:mm:ss');
        } else {
            vm.remoteUpdatedTime = '';
        }

        vm.stringContent = convertContent(vm.configuration.content, vm.configuration.contentType);
        vm.remoteStringContent = convertContent(vm.configuration.remoteContent, vm.configuration.remoteContentType);

        if (!vm.isAdd) {
            vm.configurationTypeName = $translate.instant(vm.types.configurationType[vm.configuration.type].name);
            if (vm.configuration.contentType) {
                vm.contentTypeName = $translate.instant(vm.types.contentType[vm.configuration.contentType].name);
            } else {
                vm.contentTypeName = '';
            }
            if (!vm.isGroup) {
                if (vm.configuration.remoteContentType) {
                    vm.remoteContentTypeName = $translate.instant(vm.types.contentType[vm.configuration.remoteContentType].name);
                } else {
                    vm.remoteContentTypeName = '';
                }
            }
        }

        if (!vm.isReadOnly) {
            $scope.$watch('vm.configuration.contentType', (newVal, prevVal) => {
                if (newVal && !angular.equals(newVal, prevVal)) {
                    if (prevVal && prevVal == vm.types.contentType.BINARY.value) {
                        vm.stringContent = convertContent(vm.stringContent, newVal);
                    } else if (newVal == vm.types.contentType.BINARY.value) {
                        vm.stringContent = utils.stringToBase64(vm.stringContent);
                    } else if (newVal == vm.types.contentType.JSON.value) {
                        vm.stringContent = js_beautify(vm.stringContent, {indent_size: 4});
                    }
                }
            });
        }

        if (!vm.isGroup) {
            setupGroupConfiguration();
            $scope.$watch('vm.configuration.type', (newVal, prevVal) => {
                if (newVal && !angular.equals(newVal, prevVal)) {
                    setupGroupConfiguration();
                }
            });
        }

        vm.save = save;
        vm.cancel = cancel;
    };

    function setupGroupConfiguration() {
        if (vm.configuration.type && vm.groupConfigurations[vm.configuration.type]) {
            vm.groupConfiguration = vm.groupConfigurations[vm.configuration.type];
            vm.groupConfigurationStringContent = convertContent(vm.groupConfiguration.content, vm.groupConfiguration.contentType);
            if (vm.groupConfiguration.contentType) {
                vm.groupConfigurationContentTypeName = $translate.instant(vm.types.contentType[vm.groupConfiguration.contentType].name);
            } else {
                vm.groupConfigurationContentTypeName = '';
            }
        } else {
            vm.groupConfiguration = null;
            vm.groupConfigurationStringContent = null;
            vm.groupConfigurationContentTypeName = '';
        }
    }

    function convertContent(content, contentType) {
        var stringContent = '';
        if (contentType && content) {
            if (contentType == types.contentType.JSON.value ||
                contentType == types.contentType.TEXT.value) {
                stringContent = utils.base64toString(content);
                if (contentType == types.contentType.JSON.value) {
                    stringContent = js_beautify(stringContent, {indent_size: 4});
                }
            } else {
                stringContent = angular.copy(content);
            }
        }
        return stringContent;
    }

    function cancel() {
        $mdDialog.cancel();
    }

    function save() {
        $scope.$broadcast('form-submit');
        if ($scope.theForm.$valid) {
            if (vm.configuration.useGroupConfiguration) {
                vm.configuration.contentType = null;
                vm.configuration.content = null;
            } else {
                if (vm.configuration.contentType != vm.types.contentType.BINARY.value) {
                    vm.configuration.content = utils.stringToBase64(vm.stringContent);
                } else {
                    vm.configuration.content = vm.stringContent;
                }
            }
            var promise;
            if (!vm.configuration.contentType && !vm.configuration.remoteContentType) {
                promise = configurationService.deleteConfiguration(vm.configuration.type,
                    vm.configuration.entityId.entityType, vm.configuration.entityId.id);
            } else {
                promise = configurationService.saveConfiguration(vm.configuration);
            }
            promise.then(function success() {
                $scope.theForm.$setPristine();
                $mdDialog.hide();
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/configuration/gateway-configuration.controller.js